import { Injectable } from '@angular/core';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';
import { Prescriber } from 'src/app/shared/models/services-aide-emploi/prescriber';
import { Observable } from 'rxjs';
import { Slot } from 'src/app/shared/models/services-aide-emploi/slot';

@Injectable({
	providedIn: 'root'
})
export class PrescriberService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAuthenticatedPrescriber(): Observable<Prescriber> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescriberUrl}/get`,
			'getPrescriber'
		);
	}

	registerPrescriber(prescriber: Prescriber): Observable<any> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prescriberUrl}/add`,
			'registerPrescriber',
			prescriber
		);
	}

	bookAppointment(slotBooked: Slot): Observable<Slot> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.prescriberRequestUrl}`,
			'bookAppointment',
			slotBooked
		);
	}

	getBookedAppointment(): Observable<Slot> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescriberRequestUrl}`,
			'getBookedAppointment'
		);
	}

	getBookedAppointmentByMissionRequestId(
		missionRequestId: number
	): Observable<Slot> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescriberRequestUrl}/missionRequestId/${missionRequestId}`,
			'getBookedAppointmentByMissionRequestId'
		);
	}

	updateAppointmnentStatus(
		appointmentId: string,
		status: string
	): Observable<Slot> {
		return this.genericCrudService.genericPatchDataToAPI(
			`${this.appConstants.prescriberRequestUrl}/${appointmentId}`,
			'updateAppointmnentStatus',
			status
		);
	}

	loadNewBookedAppointments(): Observable<Slot[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescriberRequestUrl}s`,
			'getBookedAppointments'
		);
	}

	loadNewBookedAppointmentsByStatus(status: string): Observable<Slot[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.prescriberRequestUrl}s/status/${status}`,
			'loadNewBookedAppointmentsByStatus'
		);
	}
}
